  <template>
  <div class="container-fluid mt-4" dir="rtl">
    
    <!-- 1. الفلاتر (بدون اختيار المجموعة) -->
    <div class="card shadow-sm mb-4 no-print border-top-primary">
      <div class="card-body">
        <div class="row g-3">
          <div class="col-md-6">
            <label class="form-label fw-bold">الفصل الدراسي</label>
            <select v-model="form.term" @change="getSubjectswithtearm(form.term)" class="form-select">
              <option value="">-- اختر الفصل --</option>
              <option v-for="t in terms" :key="t.id" :value="t">{{ t.name }}</option>
            </select>
          </div>

          <div class="col-md-6">
            <label class="form-label fw-bold">المادة</label>
            <select v-model="form.subject" class="form-select">
              <option value="">-- اختر المادة --</option>
              <option v-for="s in subjects" :key="s.id" :value="s">{{ s.name }}</option>
            </select>
          </div>
        </div>

        <div class="d-flex gap-2 mt-4 pt-3 border-top justify-content-center">
         <button @click="getResults('first')" class="btn btn-primary px-4" :disabled="loading">
     المراجعة الأولى (جميع المجموعات)
  </button>
  
  <button @click="getResults('second')" class="btn btn-outline-primary px-4" :disabled="loading">
     المراجعة الثانية (جميع المجموعات)
  </button>
  
  <button @click="getResults('third')" class="btn btn-outline-primary px-4" :disabled="loading">
     المراجعة الثالثة (جميع المجموعات)
  </button>
  
  <button @click="getResults('final')" class="btn btn-outline-primary px-4" :disabled="loading">
     المراجعة النهائية (جميع المجموعات)
  </button>

          <button @click="print" class="btn btn-dark px-4" :disabled="!hasData">
             <i class="fas fa-print ms-1"></i> طباعة الكل
          </button>
        </div>
      </div>
    </div>

    <!-- 2. منطقة الطباعة -->
    <div id="printMe" v-if="hasData">
      
      <!-- الحلقة الأولى: المرور على كل مجموعة -->
      <div v-for="(groupStudents, groupNo) in allGroups" :key="'group-'+groupNo" style="page-break-after: always;">
        
        <!-- الحلقة الثانية: تقسيم كل مجموعة لصفحات (50 طالب لكل صفحة) -->
        <div 
          v-for="(chunk, chunkIndex) in chunkStudents(groupStudents)" 
          :key="'g-'+groupNo+'-page-'+chunkIndex" 
          class="print-page" style="page-break-after: always;"
        >
            
            <!-- الترويسة -->
            <header class="page-header mb-2 border-bottom border-2 border-dark pb-2">
              <div class="d-flex justify-content-between align-items-center text-center">
                <div style="width: 30%">
                  <h6 class="mb-1 fw-bold">مديرية التربية والتعليم</h6>
                  <h6 class="mb-0 fw-bold">لجنة النظام والمراقبة</h6>
                </div>
                
                <div style="width: 40%">
                  <h3 class="fw-bold text-decoration-underline mb-1">كشف مراجعة رصد ({{ label }})</h3>
                  <h5 class="fw-bold m-0">مادة: {{ form.subject?.name }}</h5>
                </div>

                <div style="width: 30%" class="text-start ps-3">
                   <!-- كود باركود وهمي أو ترويسة -->
                   <div class="border p-1 text-center">رقم المظروف: <strong>{{ chunkIndex + 1 }}</strong></div>
                </div>
              </div>

              <div class="d-flex justify-content-between mt-2 px-2 bg-light border border-dark">
                <span class="fw-bold fs-5">مجموعة رقم: ( {{ groupNo }} )</span>
                <span class="fw-bold fs-5">صفحة رقم: ( {{ chunkIndex + 1 }} )</span>
                <span class="fw-bold fs-5">عدد الأوراق: {{ chunk.length }}</span>
              </div>
            </header>

            <!-- الجسم (العمودين) -->
            <div class="page-body d-flex gap-4">
              
              <!-- العمود الأيمن (25 طالب) -->
              <div class="flex-fill">
                <table class="table table-bordered border-dark text-center align-middle mb-0 compact-table">
                  <thead class="table-dark text-white">
                    <tr><th width="40%">سري</th><th width="35%">الدرجة</th><th width="25%">تعديل</th></tr>
                  </thead>
                  <tbody>
                    <tr v-for="student in chunk.slice(0, 25)" :key="student.SecretKey">
                      <td class="fw-bold font-monospace fs-5 bg-light">{{ student.SecretKey | scur }}</td>
                      <td class="fw-bold fs-4" :class="{'bg-secondary text-white': isAbsent(student)}">
                        {{ formatDegree(student.subject) }}
                      </td>
                      <td></td>
                    </tr>
                    <!-- ملء الفراغ -->
                    <tr v-for="n in (25 - chunk.slice(0, 25).length)" :key="'e1-'+n"><td>&nbsp;</td><td></td><td></td></tr>
                  </tbody>
                </table>
              </div>

              <!-- الفاصل -->
              <div class="vr" style="width: 2px; background: #000; opacity: 1;"></div>

              <!-- العمود الأيسر (25 طالب) -->
              <div class="flex-fill">
                <table class="table table-bordered border-dark text-center align-middle mb-0 compact-table">
                  <thead class="table-dark text-white">
                    <tr><th width="40%">سري</th><th width="35%">الدرجة</th><th width="25%">تعديل</th></tr>
                  </thead>
                  <tbody>
                    <tr v-for="student in chunk.slice(25, 50)" :key="student.SecretKey">
                      <td class="fw-bold font-monospace fs-5 bg-light">{{ student.SecretKey | scur }}</td>
                      <td class="fw-bold fs-4" :class="{'bg-secondary text-white': isAbsent(student)}">
                        {{ formatDegree(student.subject) }}
                      </td>
                      <td></td>
                    </tr>
                    <!-- ملء الفراغ -->
                    <tr v-for="n in (25 - chunk.slice(25, 50).length)" :key="'e2-'+n"><td>&nbsp;</td><td></td><td></td></tr>
                  </tbody>
                </table>
              </div>

            </div>

            <!-- التذييل -->
            <footer class="page-footer mt-auto pt-2 border-top border-2 border-dark">
              <div class="row text-center fs-5 fw-bold">
                <div class="col-4"><p class="mb-0">الراصد: ....................</p></div>
                <div class="col-4"><p class="mb-0">المراجع: ....................</p></div>
                <div class="col-4"><p class="mb-0">رئيس الحجرة: ....................</p></div>
              </div>
            </footer>

            <!-- فاصل صفحات -->
            <div class="page-break"></div>

        </div>
      </div>

    </div>
  </div>
</template>

<script>
import api from "../../api/axios";
import _ from "lodash";

export default {
  name: "ReviewGradeSheet",
  data() {
    return {
      loading: false,
      label: "أولى",
      allGroups: {}, // كائن يحتوي على المجموعات (مفتاح: رقم المجموعة، قيمة: مصفوفة الطلاب)
      subjects: [],
      terms: [],
      form: { term: "", subject: "" }, // حذفنا الـ group من هنا
    };
  },
  computed: {
    hasData() {
        return Object.keys(this.allGroups).length > 0;
    }
  },
  filters: {
    scur(val) { return val; }
  },
  mounted() {
    // جلب الترمات فقط (المجموعات ستأتي تلقائياً)
    api.get("/getterms").then(res => this.terms = res.data);
  },
  methods: {
    getSubjectswithtearm(term) {
      api.get("/getSubject/" + term.id).then(res => this.subjects = res.data);
    },

   async getResults(type) {
  if(!this.form.term || !this.form.subject) return alert('اختر الترم والمادة');
  
  this.loading = true;
  
  // قاموس للعناوين بناءً على النوع المختار
  const titles = {
      'first': 'المراجعة الأولى',
      'second': 'المراجعة الثانية',
      'third': 'المراجعة الثالثة',
      'final': 'المراجعة النهائية'
  };

  // تعيين العنوان الذي سيظهر في الطباعة
  this.label = titles[type] || 'مراجعة رصد';
  
  try {
    const res = await api.post("/checkDegreeStudentAll", { 
        term: this.form.term,
        subject: this.form.subject
    });
    
    this.allGroups = res.data; 

  } catch (e) { 
    console.error(e); 
    alert("حدث خطأ أثناء جلب البيانات");
  } finally { 
    this.loading = false; 
  }
},

    // دالة مساعدة لتقسيم طلاب المجموعة الواحدة إلى صفحات (50 طالب)
    chunkStudents(students) {
        return _.chunk(students, 50);
    },

    formatDegree(val) {
        return (val == '-1' || val == -1) ? 'غ' : val;
    },
    isAbsent(student) {
        return student.subject == '-1';
    },
    print() {
      this.$htmlToPaper("printMe");
    }
  }
};
</script>

<style scoped>
/* نفس الستايل السابق تماماً */
@media print {
  @page { size: A4 portrait; margin: 10mm; }
  body * { visibility: hidden; }
  #printMe, #printMe * { visibility: visible; }
  #printMe { position: absolute; left: 0; top: 0; width: 100%; }
  
  .print-page {
    page-break-after: always;
    page-break-inside: avoid;
    height: 98vh;
    display: flex;
    flex-direction: column;
  }

  .compact-table th, .compact-table td {
    border: 1px solid #000 !important;
    font-size: 16pt !important;
    height: 35px;
    padding: 2px !important;
  }
  
  .bg-secondary {
      background-color: #888 !important;
      color: white !important;
      -webkit-print-color-adjust: exact;
  }
}
</style>